var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overview"},[(_vm.isAuthenticated)?_c('Toolbar'):_vm._e(),_c('OverviewHeader',{attrs:{"full_name":_vm.username}}),_c('CardsGrid',{attrs:{"projects":_vm.projects}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }